import { UserFacingError } from "@/models/helper/UserFacingError";
import { IRoom } from "@/models/room/Room";
import axios from "axios";

export default class RoomService {
  static async getBorrowingRooms(
    roomLocationId: number,
    roomTypeId?: number,
    softwareIds?: string[],
    search?: string
  ): Promise<IRoom[]> {
    try {
      const res = await axios.get(
        import.meta.env.VITE_API_URL + "room/borrowing",
        {
          params: {
            room_location_id: roomLocationId,
            room_type_id: roomTypeId,
            softwares: softwareIds,
            search,
          },
          withCredentials: true,
        }
      );

      return res.data.data;
    } catch (error) {
      console.error(error);
      throw new UserFacingError({
        title: "Fetch error.",
        description: "Error fetching list of rooms.",
      });
    }
  }

  static async getAssetBorrowingRooms(
    roomLocationId: number,
    userEmail: string,
    userRole: "Student" | "Assistant",
    roomTypeId?: number,
    search?: string
  ): Promise<IRoom[]> {
    try {
      const res = await axios.get(
        import.meta.env.VITE_API_URL + "room/asset-borrowing",
        {
          params: {
            room_location_id: roomLocationId,
            room_type_id: roomTypeId,
            search: search,
            user_email: userEmail,
            user_role: userRole
          },
          withCredentials: true,
        }
      );

      return res.data.data;
    } catch (error) {
      console.error(error);
      throw new UserFacingError({
        title: "Fetch error.",
        description: "Error fetching list of rooms.",
      });
    }
  }

  static async getRoomByBorrowingPic(picInitial: string): Promise<IRoom[]> {
    try {
      const res = await axios.get(
        `${import.meta.env.VITE_API_URL}room/borrowing-pic`,
        {
          params: {
            pic: picInitial,
          },
          withCredentials: true,
        }
      );

      return res.data.data;
    } catch (error) {
      console.error("Error fetching room by PIC:", error);
      return [];
    }
  }
}
